const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

export const fetchCentrosCostos = async ({ limit = 10, offset = 1, query = {} } = {}) => {
  const response = await fetch(`${API_URL}/centro-costos/filter`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ limit, offset, query }),
  });
  if (!response.ok) throw new Error('Error al obtener los costos');
  return response.json();
};

export const createCentroCosto = async (data) => {
  const response = await fetch(`${API_URL}/centro-costos/create`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
  if (!response.ok) throw new Error('Error al crear el costo');
  return response.json();
};

export const updateCentroCosto = async (id, data) => {
  const response = await fetch(`${API_URL}/centro-costos/update/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
  if (!response.ok) throw new Error('Error al actualizar el costo');
  return response.json();
};

export const deleteCentroCosto = async (id) => {
  const response = await fetch(`${API_URL}/centro-costos/delete/${id}`, {
    method: 'DELETE',
  });
  if (!response.ok) throw new Error('Error al eliminar el costo');
  return response.json();
};
